












































































































































import Vue from 'vue';
export default Vue.extend({
  props: {
    studio: {
      type: Object,
      required: true,
    },
  },
});
